import {backendConfigUrl} from 'config';
import axios from 'axios';
import urlUtil from './url';

let fetched = false;
let backendConfig = {};
let loadingPromise = null;

const get = function() {
  if (fetched) {
    return Promise.resolve(backendConfig);
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = new Promise((resolve, reject) => {
    let url = urlUtil.randomize(backendConfigUrl);
    axios
    .get(url)
    .then(resp => {
        if (typeof resp.data !== 'object') {
          window.router.push('error');
          reject();
        }
        backendConfig = resp.data;
        resolve(backendConfig);
        fetched = true;
        loadingPromise = false;
      })
      .catch(() => {
        window.router.push('error');
        reject();
        loadingPromise = false;
      })
      // Edge has some problem with finally
      // .finally(() => {
      //   loadingPromise = false;
      // })
      ;
  });

  return loadingPromise;
};

export default {
  get,
};



// WEBPACK FOOTER //
// ./src/utils/backendConfig.js